<ui-modal
  [title]="title"
  (afterClose)="onCancel()"
  width="900px"
  height="531px"
  [footer]="footerRef"
>
  <div class="modal-body">
    <div class="map-wrapper">
      <div class="search-wrapper">
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearchInput()"
          placeholder="Поиск места... (Город, улица, здание, место, объект)"
          class="search-input"
        />
        @if (searchResults.length > 0) {
        <div class="search-results">
          @for (result of searchResults; track result) {
          <div
            class="search-result-item"
            role="button"
            tabindex="0"
            (click)="onSelectSearchResult(result)"
            (keyup.enter)="onSelectSearchResult(result)"
          >
            {{ result.display_name }}
          </div>
          }
        </div>
        } @if (isSearching) {
        <div class="search-loading">Поиск...</div>
        }
      </div>
      <div #mapContainer class="map-container"></div>
    </div>
  </div>
</ui-modal>

<ng-template #footerRef>
  <div class="flex flex-row gap-4 justify-between">
    <ui-button type="secondary" (click)="onCancel()">Отмена</ui-button>

    @if (selectedCoordinates) {
    <div>
      <div style="text-align: left">Координаты:</div>
      <div style="text-align: left">
        {{ selectedCoordinates.lat ?? 'Не указано' }},
        {{ selectedCoordinates.lon ?? 'Не указано' }}
      </div>
    </div>
    }@else {
    <div>Выберите место на карте</div>
    }

    <ui-button type="primary" [disabled]="!canConfirm" (click)="onConfirm()">
      Подтвердить
    </ui-button>
  </div>
</ng-template>
